/**
 * Global gate for the Intelligence tab redesign experience (PSCO-127).
 * A simple all-users on/off flag — when enabled, everyone gets the redesigned Intelligence
 * tab; when off, everyone falls back to the legacy Intelligence tab.
 */
import { useOrgResolvedFlag } from './useOrgResolvedFlag';
export const INTELLIGENCE_TAB_REDESIGN_FLAG = 'intelligence-tab-redesign-enabled';

export function useIntelligenceTabRedesignEnabled(): { resolved: boolean; enabled: boolean } {
  return useOrgResolvedFlag(INTELLIGENCE_TAB_REDESIGN_FLAG);
}
